<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Destino"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="data.model.destino.unidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.prestadores"
                        :validations="validations.prestador"
                        label="Prestador"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.prestadorId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.grupos"
                        :validations="validations.grupo"
                        label="Grupo de exame"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.grupoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.usuarios"
                        :validations="validations.usuario"
                        label="Profissional"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.usuarioId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="reschedule"
                color="primary"
            >
                Continuar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                prestador: {required: true},
                grupo: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            reagendamentoExame: this.getConectaSusRepository('exameImagem.reagendamentoExame'),
        }
    },
    data: () => ({
        date: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.reset()

            this.date = date

            this.$refs.RkmModal.show()

            this.getUnidades()
        },
        async getJornadas(field) {
            const request = {
                unidade_id: this.data.model.destino.unidadeId,
                infraestrutura_id: this.data.model.destino.infraestruturaId,
                exame_id: this.data.model.destino.grupoId,
                prestador_id: this.data.model.destino.prestadorId,
                field: field
            }

            return this.repositories.reagendamentoExame.getJornadasDestino(this.camelObjectKeysToSnakeRecursive(request))
        },
        getUnidades() {
            this.setLoading()

            this.getJornadas('unidade').then(responseJornadas => {

                this.data.form.destino.unidades = Object.assign(responseJornadas.data)

                if (responseJornadas.data.length === 1) {
                    this.data.model.destino.unidadeId = responseJornadas.data[0].id
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {
            this.setLoading()

            this.getJornadas('infraestrutura').then(responseJornadas => {

                this.data.form.destino.infraestruturas = Object.assign(responseJornadas.data)

                if (responseJornadas.data.length === 1) {
                    this.data.model.destino.infraestruturaId = responseJornadas.data[0].id
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getPrestadores() {
            this.setLoading()

            this.getJornadas('prestador').then(responseJornadas => {

                this.data.form.destino.prestadores = Object.assign(responseJornadas.data)

                if (responseJornadas.data.length === 1) {
                    this.data.model.destino.prestadorId = responseJornadas.data[0].id
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getGrupos() {
            this.setLoading()

            this.getJornadas('grupo').then(responseJornadas => {

                this.data.form.destino.grupos = Object.assign(responseJornadas.data)

                if (responseJornadas.data.length === 1) {
                    this.data.model.destino.grupoId = responseJornadas.data[0].id
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getUsuarios() {
            this.setLoading()

            this.getJornadas('usuario').then(responseJornadas => {

                this.data.form.destino.usuarios = Object.assign(responseJornadas.data)

                if (responseJornadas.data.length === 1) {
                    this.data.model.destino.usuarioId = responseJornadas.data[0].id
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        handleUnidadeChange() {
            this.data.form.destino.infraestruturas = []
            this.data.form.destino.prestadores = []
            this.data.form.destino.grupos = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.infraestruturaId = null
            this.data.model.destino.prestadorId = null
            this.data.model.destino.grupoId = null
            this.data.model.destino.usuarioId = null

            this.getInfraestruturas()
        },
        handleInfraestruturaChange() {
            this.data.form.destino.prestadores = []
            this.data.form.destino.grupos = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.prestadorId = null
            this.data.model.destino.grupoId = null
            this.data.model.destino.usuarioId = null

            this.getPrestadores()
        },
        handlePrestadorChange() {
            this.data.form.destino.grupos = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.grupoId = null
            this.data.model.destino.usuarioId = null

            this.getGrupos()
        },
        handleGrupoChange() {
            this.data.form.destino.usuarios = []
            this.data.model.destino.usuarioId = null

            this.getUsuarios()
        },
        reschedule() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.$refs.RkmModal.hide()
                    this.$emit('reschedule', this.date)
                })
        },
        reset() {
            this.data.form.destino.unidades = []
            this.data.form.destino.infraestruturas = []
            this.data.form.destino.prestadores = []
            this.data.form.destino.grupos = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.unidadeId = null
            this.data.model.destino.infraestruturaId = null
            this.data.model.destino.prestadorId = null
            this.data.model.destino.grupoId = null
            this.data.model.destino.usuarioId = null
        },
    },
    watch: {
        'data.model.destino.unidadeId' () {

            this.handleUnidadeChange()
        },
        'data.model.destino.infraestruturaId' () {

            this.handleInfraestruturaChange()
        },
        'data.model.destino.prestadorId' () {

            this.handlePrestadorChange()
        },
        'data.model.destino.grupoId' () {

            this.handleGrupoChange()
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>